import * as RadixTooltip from '@radix-ui/react-tooltip';
import { PropsWithChildren, ReactNode } from 'react';
import { Text } from '@pairy/pds-react';

import * as Styled from './index.styles';

interface Props {
  content: ReactNode;
  side?: RadixTooltip.TooltipContentProps['side'];
}

/**
 * 임의의 요소에 붙이는 툴팁.
 *
 * pds의 IconTooltip은 물음표 아이콘을 스스로 그려서 버튼 같은 기존 요소에는 쓸 수 없다.
 * 생김새는 IconTooltip과 동일하게 맞춰 화면 간 편차가 없게 한다.
 */
const Tooltip = ({
  content,
  side = 'top',
  children,
}: PropsWithChildren<Props>) => {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root delayDuration={200}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <Styled.Content side={side} sideOffset={8}>
            <Text variant="sm-medium" color="white" textAlign="center">
              {content}
            </Text>
          </Styled.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

export default Tooltip;
